export const defaultStyles = {
  color: "var(--theme-website-color-text-link)",
  textTransform: "none",
  fontStyle: "normal",
  fontWeight: "500",
  fontSize: "16px",
  lineHeight: "1",
  textAlign: "left",
  textDecoration: "underline",
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
  },
  padding: {
    paddingTop: "0",
    paddingBottom: "0",
    paddingLeft: "0",
    paddingRight: "0",
  },
} as const;
